import { useEffect } from "react";

export default function Loader({ text, color = "#181818" }: { text: string; color: string }) {
    useEffect(() => {
        async function getLoader() {
            const { ring2 } = await import("ldrs");
            ring2.register();
        }
        getLoader();
    }, []);

    return (
        <div className='flex items-center gap-4'>
            <l-ring-2
                size='32'
                stroke='5'
                stroke-length='0.25'
                bg-opacity='0.1'
                speed='0.8'
                color={color}
            ></l-ring-2>
            <div>{text}</div>
        </div>
    );
}
